/* CARLINA – remet tous les prix au format 79,90 € (theme + Easy Bundle) */
(function(){
  if (window.__clPriceFix) return;
  window.__clPriceFix = true;
  var PRICE_SEL = [
    '.gbbMixNativeProductPagePrice__totalPrice',
    '.gbbMixNativeProductPagePrice__compareAtPrice',
    '.gbbMixInlineAddToCartBtnPrice',
    '.gbbMixInlineAddToCartBtnCompareAtPrice',
    '.gbbMixInlineDiscountedPriceValue',
    '.gbbMixInlineStrikeThroughPriceValue',
    '.gbbMixProductCardPrice',
    '.gbbMixProductCardComparePrice',
    '.price-item'
  ].join(',');
  var NBSP = '\u00a0';
  var RE_TXT = /€\s*(\d{1,3}(?:[\s.,\u202f]\d{3})*|\d+)(?:[.,](\d{1,2}))?(?![\d])/g;
  function fmtNum(ent, dec){
    var e = String(ent).replace(/[\s.,\u202f]/g, '');
    e = e.replace(/\B(?=(\d{3})+(?!\d))/g, '\u202f');
    if (dec === undefined || dec === '') return e + NBSP + '€';
    if (dec.length === 1) dec = dec + '0';
    return e + ',' + dec + NBSP + '€';
  }
  function fixString(t){
    if (!t || t.indexOf('€') === -1) return t;
    return t.replace(RE_TXT, function(_, ent, dec){ return fmtNum(ent, dec); });
  }
  function fixPriceEls(){
    var els = document.querySelectorAll(PRICE_SEL);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.querySelector(PRICE_SEL)) continue;
      var full = el.textContent;
      if (!full || full.indexOf('€') === -1) continue;
      var trimmed = full.replace(/\s+/g, ' ').trim();
      if (/^€/.test(trimmed)) {
        var out = fixString(trimmed.replace(/^€\s*/, '€'));
        if (out !== trimmed && el.textContent !== out) el.textContent = out;
      }
    }
  }
  function fixTextNodes(){
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = w.nextNode())) {
      var t = n.nodeValue;
      if (!t || t.indexOf('€') === -1) continue;
      var out = fixString(t);
      if (out !== t) n.nodeValue = out;
    }
  }
  function run(){ fixPriceEls(); fixTextNodes(); }
  var pending = false;
  var mo = new MutationObserver(function(){
    if (pending) return;
    pending = true;
    requestAnimationFrame(function(){ pending = false; run(); });
  });
  function start(){
    run();
    mo.observe(document.body, { childList: true, subtree: true, characterData: true });
    var ticks = 0;
    var iv = setInterval(function(){ run(); if (++ticks > 20) clearInterval(iv); }, 500);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
